// ** Custom Components
import { createIconComponent } from "./createIconComponent";

// #####################################################

/**
 * User Icons Component
 */
export const UserCircleSolidIcon = createIconComponent("user-circle", "solid");

export const UserCircleRegularIcon = createIconComponent(
	"user-circle",
	"regular",
);

// #####################################################
